/* @refresh reload */
import '@/sentry'
import { runEngineSmokeTest } from './engine_test'
import { render } from 'solid-js/web'
import routerFunction from "./router"
import './sass/index.sass'

const root = document.getElementById('root') as HTMLElement

render(routerFunction, root)
void runEngineSmokeTest().catch((error) => console.error('[engine-test]', error))
